import { Col, Container, Row } from 'react-angle-dashboard-components'
import { Controller, useFormContext } from 'react-hook-form'
import { IQuoteFormData } from '../../QuoteForm'
import { Heading, InvalidFeedback, SmallGrayHeading } from '../../style'

import SelectCard from './SelectCard'
import FooterNav from '../../FooterNav'
import { useVendorChoices } from '../../../../hooks/quote.hooks'

const BasicInfoStep3 = () => {
  const { control, formState, watch } = useFormContext<IQuoteFormData>()

  const errors = formState.errors.basicInfo?.step3

  const { data } = useVendorChoices(watch('entryId'))

  const pbmOptions = data?.pbm ?? []

  return (
    <Container className="p-4">
      <Row className="pb-5">
        <Col>
          <SmallGrayHeading>Basic Quote Info (3/3)</SmallGrayHeading>
          <Heading className="pt-1">
            Select Your Pharmacy Benefits Manager
          </Heading>
          {errors?.pharmBenefitsManagerId && (
            <InvalidFeedback>
              {errors?.pharmBenefitsManagerId?.message}
            </InvalidFeedback>
          )}
        </Col>
      </Row>
      <Row className="g-2">
        <Controller
          control={control}
          name="basicInfo.step3.pharmBenefitsManagerId"
          render={({ field: { value, onChange } }) => (
            <>
              {pbmOptions.map(
                ({ entryId, programName, logoUrl, description }) => (
                  <Col className="col-auto" key={entryId}>
                    <SelectCard
                      title={programName}
                      description={description}
                      image={logoUrl}
                      checked={value === entryId}
                      onClick={() => {
                        onChange(entryId)
                      }}
                      checkGroupName="step3Benefits"
                    />
                  </Col>
                )
              )}
            </>
          )}
        />
      </Row>
      <FooterNav triggerPath="basicInfo.step3" />
    </Container>
  )
}

export default BasicInfoStep3
